import { CellProps } from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";
import { useEffect, useState } from "react";

import { Input } from "@/components/primitives/input";

function NumberCellComponent({
  data,
  handleChange,
  path,
  enabled,
  schema,
}: CellProps) {
  const [rawValue, setRawValue] = useState(data == null ? "" : String(data));

  useEffect(() => {
    setRawValue(data == null ? "" : String(data));
  }, [data]);

  return (
    <Input
      type="number"
      value={rawValue}
      onChange={(e) => {
        const value = e.target.value;
        setRawValue(value);
        if (value === "") {
          handleChange(path, undefined);
          return;
        }
        const parsedValue = e.target.valueAsNumber;
        if (!Number.isNaN(parsedValue)) {
          handleChange(path, parsedValue);
        }
      }}
      disabled={!enabled}
      size="sm"
      min={schema.minimum}
      max={schema.maximum}
    />
  );
}

export const NumberCell = withJsonFormsCellProps(NumberCellComponent);
